import { FC, useCallback, useContext, useEffect, useState } from "react";

import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Spinner } from "capitalrx-components-2.0/lib/general";
import styles from "./MedicalClaimsSearchPage.module.scss";

import { AuthenticationContext } from "@/context";
import { MedicalClaimsProviderList, MedicalClaimsSearchForm } from "../../components";

export const MedicalClaimsSearchPage: FC = () => {
  const { isUserLoggedIn, getUser } = useContext(AuthenticationContext);
  const [loading, setLoading] = useState(false);
  const [hasActiveAccount, setHasActiveAccount] = useState(false);

  const checkUser = useCallback(async () => {
    if (!isUserLoggedIn()) {
      setHasActiveAccount(false);
      return;
    }

    setLoading(true);
    const user = await getUser();
    setLoading(false);

    setHasActiveAccount(user.provider_enrollment_status === "active");
  }, [getUser, isUserLoggedIn]);

  useEffect(() => {
    checkUser();
  }, [checkUser]);

  return (
    <>
      {loading && (
        <Stack className={styles.LoadingContainer} alignment="center">
          <Spinner className={styles.LoadingSpinner} size="large" />
        </Stack>
      )}
      {!loading && (
        <div className={!hasActiveAccount ? styles.MedicalClaimsPanelContainer : styles.MedicalClaimsProviderContainer}>
          <Stack spacing="large">
            {!hasActiveAccount && <MedicalClaimsSearchForm />}
            {hasActiveAccount && <MedicalClaimsProviderList />}
          </Stack>
        </div>
      )}
    </>
  );
};
